import { buildQuery } from '@calendly/http-tools'

import { Settings } from 'services/settings'

// PPCP: Venmo — https://developer.paypal.com/docs/multiparty/checkout/pay-with-venmo/integrate/
//       Card — https://developer.paypal.com/docs/checkout/advanced/customize/standalone-buttons/
const PPCP_FUNDING_PARAMS = {
  'enable-funding': 'venmo,card'
}

export function buildLegacyPaypalSdkQuery(externalUserId, providerLocale, currency) {
  return buildQuery({
    'client-id': Settings.paypal.client_id,
    'merchant-id': externalUserId,
    intent: 'authorize',
    commit: 'false',
    locale: providerLocale,
    currency,
    'disable-funding': 'credit,card'
  })
}

export function buildPpcpPaypalSdkQuery(externalUserId, providerLocale, currency) {
  return buildQuery({
    'client-id': Settings.paypal_ppcp.client_id,
    'merchant-id': externalUserId,
    intent: 'authorize',
    commit: 'false',
    locale: providerLocale,
    currency,
    'disable-funding': 'credit',
    ...PPCP_FUNDING_PARAMS
  })
}
